import { buildSandboxedHtml } from "./sandboxed-html";

interface MessageHtmlFrameProps {
  body: string;
}

/**
 * Sandboxed iframe for rendering message HTML bodies.
 *
 * Defense-in-depth layers:
 *   1. `sandbox=""` (empty) — no allow-scripts, no allow-same-origin,
 *      no allow-forms, no allow-top-navigation. The iframe is opaque to
 *      its parent, can't run JS, can't read cookies/localStorage.
 *   2. `srcdoc` (not `src`) — the body content has no top-level URL,
 *      so it can never be navigated to or hot-linked.
 *   3. Inline `<meta http-equiv="Content-Security-Policy">` (built by
 *      `buildSandboxedHtml`) — blocks remote resource loads.
 *
 * Tracking pixels in test emails arrive through SES like any other
 * inline `<img src>`. CSP `img-src data:` makes the browser refuse
 * the request before the parent realm even sees a network event.
 */
export function MessageHtmlFrame({ body }: MessageHtmlFrameProps): React.ReactElement {
  return (
    <iframe
      data-testid="message-html-iframe"
      title="Email HTML body"
      sandbox=""
      srcDoc={buildSandboxedHtml(body)}
      className="h-[60vh] min-h-[300px] w-full rounded-md border bg-white"
    />
  );
}
